<template>
  <b-container class="h-100 ems-page">
    <b-row class="pt-5 pb-5">
      <b-col><img src="@/App/assets/logo.png" height="100px" /></b-col>
    </b-row>
    <b-row align-h="center">
      <b-col lg="6" md="6" sm="12">
        <b-alert id="login__error-required" :show="!!errorMessage" variant="danger">
          {{ errorMessage }}
        </b-alert>
        <b-form id="login__form" @submit.prevent="onSubmit()">
          <b-form-group :invalid-feedback="usernameFieldFeedback">
            <b-form-input
              id="login__username-or-email"
              v-model="form.username"
              data-cy-username
              type="text"
              placeholder="Username or email"
              :state="isUsernameValid"
              @input="onType()"
            />
          </b-form-group>
          <b-form-group :invalid-feedback="passwordFieldFeedback">
            <b-form-input
              id="login__password"
              v-model="form.password"
              data-cy-password
              type="password"
              placeholder="Password"
              :state="isPasswordValid"
              @input="onType()"
              @keyup.enter="onSubmit()"
            />
          </b-form-group>

          <b-button
            v-show="!isLoading"
            id="login__signin-button"
            data-cy-login-button
            variant="danger"
            block
            class="mt-5 mb-5"
            @click.prevent="onSubmit()"
          >
            Login
          </b-button>

          <b-button
            v-show="isLoading"
            id="login__signin-loading-indicator"
            variant="danger"
            block
            class="mt-5 mb-5"
            disabled
          >
            <b-spinner small />
            Logging in...
          </b-button>

          <b-link :href="passwordResetUrl" class="text-danger" target="_blank">
            <strong>Reset Password</strong>
          </b-link>
        </b-form>
      </b-col>
    </b-row>
    <br />
    <br />
    <ContactInfo />
  </b-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import config from "@/App/config";
import ContactInfo from "@/App/components/ContactInfo.vue";

export default {
  name: "Login",
  components: { ContactInfo },
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapState("Login", ["usernameError", "passwordError", "errorMessage", "isLoading"]),
    isUsernameValid() {
      return this.usernameError ? false : undefined;
    },
    usernameFieldFeedback() {
      return this.usernameError;
    },
    isPasswordValid() {
      return this.passwordError ? false : undefined;
    },
    passwordFieldFeedback() {
      return this.passwordError;
    },
    passwordResetUrl() {
      return `${config.RESET_PASSWORD_URL}/password/forgot`;
    },
  },
  methods: {
    ...mapActions("Login", ["login"]),
    onSubmit() {
      this.login(this.form);
    },
    onType() {
      this.$store.commit("Login/CLEAR_ERRORS");
    },
  },
};
</script>
